import * as React from 'react';
import Popover from '@mui/material/Popover';
import { Box, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CustomText from 'components/common/CustomText/CustomText';
import EditIcon from 'icons/EditIcon';
import DeleteIcon from 'icons/DeleteIcon';
import { colors } from 'styles/colors';
import ExportAccordion from '../ExportAccordion/ExportAccordion';
import useGlobalStyles from 'styles/globalStyles';
import { useNavigate } from 'react-router-dom';
import DeleteCasesDialog from '../DeleteCasesDialog/DeleteCasesDialog';
import { useAuth } from 'context/AuthContext';

interface Props {
  patientId: number;
}

export default function PatientOptions({ patientId }: Props) {
  const { user } = useAuth();
  const globalStyles = useGlobalStyles();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [openDelete, setOpenDelete] = React.useState<boolean>(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditClick = () => {
    navigate(`/patients/${patientId}/edit`);
  }

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>

      <IconButton onClick={handleClick}>
        <MoreVertIcon sx={{ color: colors.secondary }} />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '10px',
            overflow: 'hidden',
            maxWidth: '200px'
          }}
          p={1}
        >
          <ExportAccordion />
          <IconButton
            onClick={handleEditClick}
            className={globalStyles.popoverButtonContainer}
          >
            <Box className={globalStyles.popoverIconContainer}>
              <EditIcon color={colors.black} />
            </Box>
            <CustomText text="Edit" ml="5px" color={colors.black} />
          </IconButton>

          <IconButton className={globalStyles.popoverButtonContainer} onClick={() => setOpenDelete(true)}>
            <Box className={globalStyles.popoverIconContainer}>
              <DeleteIcon color={colors.black} />
            </Box>
            <CustomText text="Delete" ml="5px" color={colors.black} />
          </IconButton>
        </Box>
      </Popover>

      <DeleteCasesDialog
        open={openDelete}
        setOpen={setOpenDelete}
        userId={user.id}
        procedureIds={[patientId]}
        after={() => navigate(-1)}
      />
    </div>
  );
}
